import Head from 'next/head'
import { useRouter } from 'next/router'
import { FC, Fragment, PropsWithChildren, useMemo } from 'react'

import { CompetitionsEndSoon } from '@/components/Competition'
import BannerSlider from '@/components/homepage/BannerSlider'
import WebInfo from '@/components/homepage/WebInfo'
import WinnerCarousel from '@/components/homepage/WinnerCarousel'
import { useLanguage } from '@/hooks/Contexts'

import { AppLayoutProps } from './props'

export const AppLayout: FC<PropsWithChildren<AppLayoutProps>> = ({ children, title, titleOuterCls, titleInnerCls, outerCls, innerCls, filter, showBanner }) => {
  const { pathname } = useRouter()
  const { navigation: navStr } = useLanguage()
  const titleStr = useMemo(() => (title ? (navStr[title] ?? title) + ' - ' + navStr.app_name : navStr.app_name), [navStr, title])
  return (
    <Fragment>
      <Head>
        {/* <title> belongs inside the guard too. The detail page renders its own generated
            title in MetaTags, but this one used to sit outside and won on the client (title
            has no key to dedupe on), so the browser tab fell back to the bare brand name
            after hydration even though the SSR HTML had the prize name. */}
        {pathname == '/competitions/[shortName]' ? null : (
          <>
            <title>{titleStr}</title>
            <meta name='title' content={titleStr} key='title' />
            <meta property='og:title' content={titleStr} key='og:title' />
            <meta name='twitter:title' content={titleStr} key='twitter:title' />
          </>
        )}
      </Head>

      {showBanner ? <BannerSlider /> : null}

      {title || filter ? (
        <div className={`animate-fade-in-down bg-white/100 shadow-[3px_4px_15px_0px_#0000000D]${showBanner ? '' : ' mt-16 md:mt-20'} ${titleOuterCls || ''}`}>
          <div className={`container-white ${titleInnerCls || ''}`}>
            {title ? <h1 className='text-xl font-medium capitalize md:text-2xl'>{navStr[title] || title.replace(/_/g, '')}</h1> : null}
            {filter}
          </div>
        </div>
      ) : null}

      {children ? (
        <div className={`fluid-gray animate-fade-in-down${title || filter || showBanner ? '' : ' mt-16 md:mt-20'} ${outerCls || ''}`}>
          <div className={`container-gray ${innerCls || ''}`}>{children}</div>
        </div>
      ) : null}

      {showBanner ? (
        <Fragment>
          <WebInfo />
          <WinnerCarousel />
          <CompetitionsEndSoon />
        </Fragment>
      ) : null}
    </Fragment>
  )
}
export default AppLayout
